export const PROFILE = {
    status: 'D',
    rank: 10,
};

export const PACKAGE_NAME =
    '@reliv/transfer-calculator';

export const SHIPPING_STORAGE_KEY =
    'relivTransferCalculatorShipping';

export const SHIPPING_IS_SUBMITTED_STORAGE_KEY =
    `relivTransferCalculatorShippingIsSubmitted`;
